function validate(cns)
{
  if (cns == null || cns.length != 15)
  {
      return false
  }

  //1. Rotina de validação de Números que iniciam com 1 ou 2:
  if (cns[0] == 1 || cns[0] == 2)
  {
      var soma;
      var resto, dv;
      var pis = "";
      var resultado = "";
      pis = cns.substr(0, 11);

      soma = (pis.substr(0, 1) * 15) +
              (pis.substr(1, 1) * 14) +
              (pis.substr(2, 1) * 13) +
              (pis.substr(3, 1) * 12) +
              (pis.substr(4, 1) * 11) +
              (pis.substr(5, 1) * 10) +
              (pis.substr(6, 1) * 9) +
              (pis.substr(7, 1) * 8) +
              (pis.substr(8, 1) * 7) +
              (pis.substr(9, 1) * 6) +
              (pis.substr(10, 1) * 5);

      //1º teste
      resto = soma % 11;
      dv = 11 - resto;

      //2º teste
      if (dv == 11)
      {
          dv = 0;
      }

      //3º teste
      if (dv == 10)
      {
          soma += 2;

          resto = soma % 11;
          dv = 11 - resto;
          resultado = pis + "001" + dv;
      }
      else
      {
          resultado = pis + "000" + dv;
      }
      if(cns == resultado)
      return true
  }


  //2. Rotina de validação de Números que iniciam com 7, 8 ou 9:
  if (cns[0] == 7 || cns[0] == 8 || cns[0] == 9)
  {
      soma = (cns.substr(0, 1) * 15) +
              (cns.substr(1, 1) * 14) +
              (cns.substr(2, 1) * 13) +
              (cns.substr(3, 1) * 12) +
              (cns.substr(4, 1) * 11) +
              (cns.substr(5, 1) * 10) +
              (cns.substr(6, 1) * 9) +
              (cns.substr(7, 1) * 8) +
              (cns.substr(8, 1) * 7) +
              (cns.substr(9, 1) * 6) +
              (cns.substr(10, 1) * 5) +
              (cns.substr(11, 1) * 4) +
              (cns.substr(12, 1) * 3) +
              (cns.substr(13, 1) * 2) +
              (cns.substr(14, 1) * 1);


      resto = soma % 11;

      return resto == 0
  }

  //se for 3, 4, 5 ou 6 é inválido
  return false
  }
  export default validate